

















import { Component, Vue, Prop } from "vue-property-decorator";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Categoria, CategoriasService } from "@/services/categorias.service";
import Loading from "@/shared/components/loading.vue";
interface Option {
  id: string;
  label: string;
  children?: Option[];
}

@Component({
  components: {
    Treeselect,
    Loading,
  },
})
export default class TreeSelectCategorias extends Vue {
  @Prop({ default: null }) value!: string;
  options = [] as Option[];
  loading = false;
  created() {
    this.fetchCategorias();
  }
  async fetchCategorias() {
    this.loading = true;
    const categorias = await CategoriasService.listarCategorias(
      this.$route.params.idCatalogo
    );
    this.options = categorias.map((categoria) => {
      return this.recursiveMap(categoria);
    });
    this.loading = false;
  }
  recursiveMap(categoria: Categoria): Option {
    if (categoria.categorias.length == 0) {
      return {
        id: categoria.idCategoria,
        label: categoria.nome,
      };
    } else {
      const cats = categoria.categorias.map((cat) => {
        return this.recursiveMap(cat);
      });
      return {
        id: categoria.idCategoria,
        label: categoria.nome,
        children: cats,
      };
    }
  }
  get idCategoriaSelecionada() {
    return this.value;
  }

  set idCategoriaSelecionada(val) {
    this.$emit("input", val);
  }
}
